@if (isOpen()) {
  <div
    class="sidebar-backdrop"
    (click)="close()"
    role="button"
    tabindex="0"
    (keydown)="onBackdropKey($event)"
    aria-label="Close menu"></div>
}
<aside
  class="dashboard-sidebar"
  [class.sidebar-open]="isOpen()"
  aria-label="Main menu">
  <nav class="sidebar-nav">
    <div class="sidebar-section">
      <a
        routerLink="/dashboard"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="sidebar-link">
        <i class="bi bi-house"></i>
        <span>Dashboard</span>
      </a>
    </div>
    <div class="sidebar-section">
      <div class="sidebar-section-header">ACCOUNT</div>
      <a
        routerLink="/dashboard/subscriptions"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-credit-card"></i>
        <span>Subscriptions</span>
      </a>
      <a
        routerLink="/dashboard/my-profile"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-person"></i>
        <span>My Profile</span>
      </a>
      <a
        routerLink="/dashboard/settings"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-gear"></i>
        <span>Settings</span>
      </a>
    </div>
    <div class="sidebar-section sidebar-section-study">
      <div class="sidebar-section-header">STUDY</div>
      <a
        routerLink="/dashboard/question-flags"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-flag"></i>
        <span>Flagged Questions</span>
      </a>
      <a
        routerLink="/dashboard/my-comments"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-chat-left-text"></i>
        <span>My Comments</span>
      </a>
      <a
        routerLink="/dashboard/my-notes"
        routerLinkActive="active"
        class="sidebar-link">
        <i class="bi bi-sticky"></i>
        <span>My Notes</span>
      </a>
    </div>
    @if (messagingEnabled) {
    <div class="sidebar-section sidebar-section-comm">
      <div class="sidebar-section-header">SOCIAL</div>
      <a
        routerLink="/dashboard/messages"
        routerLinkActive="active"
        class="sidebar-link sidebar-link-messages">
        <i class="bi bi-envelope"></i>
        <span>Messages</span>
        @if (unreadCount > 0) {
          <span class="sidebar-badge">{{ unreadCount }}</span>
        }
      </a>
    </div>
    }
    @if (isAdmin()) {
      <div class="sidebar-section">
        <div class="sidebar-section-header">ADMIN</div>
        <a
          routerLink="/admin"
          routerLinkActive="active"
          class="sidebar-link sidebar-link-admin">
          <i class="bi bi-gear-wide-connected"></i>
          <span>Admin</span>
        </a>
      </div>
    }
  </nav>
</aside>
